export const RETAILER_LINK = "https://www.nuorder.com/marketplace-application/";

export const BRAND_LINK = "https://www.nuorder.com/demo-request/";

export const LAUNCH_DARKLY_ANONYMOUS_USER_KEY = "ANONYMOUS_USER";
